import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Loading from '../Components/Common/Loading/Loading';
import CountDown from '../Components/Common/CountDown/CountDown';

// Lazy Load Sub-Routers
const ClientRoutes = lazy(() => import('./ClientRoutes/ClientRoutes'));
const ServiceProviderRoutes = lazy(() => import('./ServiceProviderRoutes/ServiceProviderRoute'));


// Lazy Load Auth Pages
const Login = lazy(() => import('../Pages/Auth/LoginPage/Login'));
const Register = lazy(() => import('../Pages/Auth/RegisterPage/Register'));
const OTPVerification = lazy(() => import('../Pages/Auth/LoginPage/OtpPage/OTPVerification'));

const AppRoutes = () => {
  return (
    <>
      <CountDown /> {/* ✅ Only here, not in ClientRoutes */}
      <Suspense fallback={<div className="top-progress-bar" />}>
        <Routes>
          {/* AUTH - No Navbar */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/otp" element={<OTPVerification />} />

          {/* WORKSPACE MANAGEMENT ZONE */}
          <Route path="/workspace/*" element={<ServiceProviderRoutes />} /> {/* ✅ added /* */}

          {/* CLIENT ZONE */}
          <Route path="/*" element={<ClientRoutes />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default AppRoutes;
